import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isFor = ['Personas en crisis de identidad o transiciones laborales que necesitan claridad inmediata.', 'Buscadores espirituales que quieren una herramienta práctica y no solo teoría.', 'Mujeres y hombres que desean liderar su vida desde su verdadera autoridad personal.', 'Emprendedores que quieren alinear su negocio con su propósito de vida.'];
const notFor = ['Personas que buscan una solución mágica sin hacer el mínimo ejercicio de introspección.', 'Quienes prefieren informes genéricos de computadora en lugar de un sistema de autodescubrimiento activo.', 'Aquellos que no están dispuestos a cuestionar sus viejas etiquetas.'];
export function WhoIsItFor() {
  return <section className="py-24 bg-white" data-id="element-175">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-177">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-trino-cream/50 border border-trino-peach/50 rounded-2xl p-8 sm:p-10" data-id="element-178">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-trino-burgundy mb-8 flex items-center" data-id="element-179">
              <span className="bg-green-100 text-green-600 p-2 rounded-full mr-4" data-id="element-180">
                <Check className="w-6 h-6" data-id="element-181" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-182">
              {isFor.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-183">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-184" />
                  <span className="text-trino-dark/80 leading-relaxed" data-id="element-185">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 border border-gray-200 rounded-2xl p-8 sm:p-10" data-id="element-186">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mb-8 flex items-center" data-id="element-187">
              <span className="bg-red-100 text-red-600 p-2 rounded-full mr-4" data-id="element-188">
                <X className="w-6 h-6" data-id="element-189" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-190">
              {notFor.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-191">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-192" />
                  <span className="text-gray-600 leading-relaxed" data-id="element-193">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}